import React, { useRef, useEffect } from "react";
import NewsCard from "./NewsCard/NewsCard";
import { Grid, Grow } from "@material-ui/core";
import { useArticle } from "../../../Contexts/ArticleContext";
import { usePaginatedArticles } from "../../../Contexts/PaginatedArticleContext";
import { useCurrentPage } from "../../../Contexts/CurrentPageContext";
import { useStyle } from "./style";
import ButtonBar from "./ButtonBar/ButtonBar";

const NewsCards = () => {
  const classes = useStyle();
  const [articles, setArticles] = useArticle();
  const [paginatedArticles, setPaginatedArticles] = usePaginatedArticles();
  const [currentPage, setCurrentPage] = useCurrentPage();
  const newsCardsRef = useRef();
  const start = (currentPage - 1) * 6;

  const filterItems = () => {
    const page_number = currentPage - 1;
    const start_loop = page_number * 6;
    const end_loop = start_loop + 6;

    setPaginatedArticles(articles.slice(start_loop, end_loop));
  };

  useEffect(() => {
    if (paginatedArticles.length) {
      window.scroll(0, newsCardsRef.current.offsetTop - 50);
    }
  }, [paginatedArticles]);

  useEffect(() => {
    if (articles.length) {
      filterItems();
    }
  }, [articles, currentPage]);

  if (!paginatedArticles.length) {
    return <></>;
  }
  return (
    <section>
      <div className={classes.newsContainer}>
        <h1 className={classes.heading}>Here Are The Latest News Headlines</h1>
        <Grow in>
          <Grid
            container
            alignItems="stretch"
            spacing={6}
            className={classes.container}
            ref={newsCardsRef}
          >
            {paginatedArticles.map((article, i) => (
              <Grid item xs={12} sm={6} md={4} key={article.title + " " + i}>
                <NewsCard article={article} index={start + i} />
              </Grid>
            ))}
          </Grid>
        </Grow>
        <ButtonBar />
      </div>
    </section>
  );
};

export default NewsCards;
